import { httpClient } from "../http/httpClient";
import { PartnerType } from "@/app/utils/partners.enum";
import { AuthorizationStatusEnum } from "./getAuthorization";

export type GetAuthorizationIdParams = {
  type: PartnerType;
};

export type GetAuthorizationIdResponse = {
  _id: string;
  seller: {
    _id: string;
    name: string;
  };
  customer: {
    _id: string;
    name: string;
    cpf: string;
  };
  status: AuthorizationStatusEnum;
  type?: PartnerType;
  authorizationLink: string;
  linkExpirationDate: string;
  autorizacaoEnviada?: boolean;
  observation?: string;
  createdAt: string;
  updatedAt: string;
};

export const getAuthorizationId = async (
  id: string,
  params: GetAuthorizationIdParams,
) => {
  const { data } = await httpClient.get<GetAuthorizationIdResponse>(
    `/pre-transaction/${id}`,
    { params, journey: params.type },
  );

  return data;
};
